<template>
  <div class="list row">
    <h2>Tipovi guma</h2>
    <div class="actions d-flex flex-row-reverse">
      <button
        type="button"
        class="btn btn-primary bi bi-arrow-clockwise"
        @click="refreshData"
      />
      <button
        type="button"
        class="btn btn-success bi bi-plus"
        @click="addData"
      />
    </div>
    <data-table
      url="tires-type"
      :columns="columns"
      :templates="templates"
      :headings="headers"
      :actions="actions"
      ref="datatable"
      @yes="deleteData"
      name="TiresType"
    >
    </data-table>
  </div>
</template>

<script>
import TiresTypeDataService from "../../services/tires-type.service";
import DataTable from "../widgets/DataTable.vue";
import TiresTypeForm from "./TiresTypeForm.vue";

export default {
  name: "tires-type",
  components: {
    DataTable,
  },
  data() {
    return {
      columns: ["name", "edit"],
      headers: {
        name: "Naziv",
        edit: "",
      },
      templates: {},
      actions: {
        edit: { commp: TiresTypeForm },
        delete: {
          deleteData: this.deleteData,
          color: "danger",
          icon: "bi-trash",
        },
      },
      currentTutorial: null,
      currentIndex: -1,
      title: "",
    };
  },
  methods: {
    refreshData() {
      this.$refs.datatable.onRefresh();
    },
    addData() {
      this.$store.commit("app/showModal", {
        modal: TiresTypeForm,
        params: { data: {}, title: "Dodaj novi tip guma" },
      });
    },
    deleteData(id) {
      TiresTypeDataService.delete(id)
        .then((response) => {
          this.$store.commit("app/showAlert", {
            type: "success",
            message: response.data.message,
          });
          this.$store.commit("app/hideModal");
        })
        .catch((e) => {
          console.log(e);
          this.$store.commit("app/showAlert", {
            type: "danger",
            message: e,
          });
        });
    },
  },
};
</script>

<style scoped>
.list {
  text-align: left;
  margin: auto;
}
</style>
